module.exports = __webpack_public_path__ + "img/vr-bg.3e204332.jpg";